module.exports = __webpack_public_path__ + "media/components/images/flows/2-48e06b3a67fb7f7c7277e88a8994eaf7.svg";